define('models/pages/trade/offer/repeat/index',['require','models/base/model','models/base/modal','models/base/sync-collection','models/base/sync-collection-model'],function(require) {
    'use strict';

    var Model = require('models/base/model'),
        ModalModel = require('models/base/modal'),
        SyncCollection = require('models/base/sync-collection'),
        SyncCollectionModel = require('models/base/sync-collection-model');

    // tradeId -> tradeAreaId
    var TradeModel = SyncCollectionModel.extend({
        urlPath: '/repeat/trade',
        defaults: {
            tradeId: 0,
            selectedTradeId: 0
        },
        constructor: function() {
            SyncCollectionModel.apply(this, arguments);

            var _this = this;
            this.items.on('change:selected', function(model) {
                _this.set('selectedTradeId', model.get('id'));
            });

            this.on('change:tradeId', this.load);

            this.on('afterLoad', function() {
                if (this.items.length) {
                    this.items.at(0).set('selected', true);
                }
            });
        },
        urlParams: function() {
            var params = SyncCollectionModel.prototype.urlParams.apply(this, arguments);
            params.tradeId = this.get('tradeId');
            return params;
        }
    });

    var RequestItem = Model.extend({
        defaults: {
            selected: false
        }
    });

    var RequestItemCollection = SyncCollection.extend({
        model: RequestItem
    });

    var RequestModel = SyncCollectionModel.extend({
        urlPath: '/repeat/request',
        defaults: {
            tradeId: 0
        },
        collectionClass: RequestItemCollection,
        constructor: function() {
            SyncCollectionModel.apply(this, arguments);

            this.on('change:tradeId', this.load);
        },
        urlParams: function() {
            var params = SyncCollectionModel.prototype.urlParams.apply(this, arguments);
            params.tradeId = this.get('tradeId');
            return params;
        }
    });

    var ProcessedModalModel = ModalModel.extend({
        defaults: {
            'title': 'Повтор заказа',
            'buttons': [
                { caption: 'Отмена', className: '', 'action': 'cancel' },
                { caption: 'Ок', className: 'btn-success', 'action': 'submit' }
            ],
            body: '',
            tradeId: 0
        },
        constructor: function() {
            ModalModel.apply(this, arguments);

            var trade = this.trade = new TradeModel();
            var request = this.request = new RequestModel();

            this.on('change:tradeId', function(model, value) {
                trade.set('tradeId', value);
            });

            trade.on('change:selectedTradeId', function(model, value) {
                request.set('tradeId', value);
            });
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.trade.dispose();
            this.request.dispose();
            ModalModel.prototype.dispose.apply(this, arguments);
        }
    });

    return ProcessedModalModel;
});
